module.exports = __webpack_public_path__ + "static/assets/03562df738acb5b29670d58970eb432f.svg";